import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { DialogService } from 'primeng/dynamicdialog';
import { AideModel } from '../models/AideModel';
import { AideEditComponent } from './aide-edit.component';
import { AideService } from './aide.service';
import { PermissionService } from '../services/permission.service';

@Component({
  selector: 'aide',
  templateUrl: './aide.component.html',
  styleUrls: ['./aide.component.css'],
})
export class AideComponent implements OnInit {
  @Input() baseCode: string;
  @Input() code: string;
  @Input() placement: 'top' | 'bottom' | 'left' | 'right' | 'auto' | 'top left' | 'top right' | 'right top' | 'right bottom' | 'bottom right' | 'bottom left' | 'left bottom' | 'left top' = 'auto';
  @Input() adaptivePosition: boolean = false;

  @ViewChild('pop', { static: false }) public popover: PopoverDirective;

  get aide(): string {
    return (this.baseCode ? this.baseCode + '.' : '') + this.code;
  }

  get tooltipValue(): string | null {
    return this.aide ? this.aideService.SharedAide[this.aide] : null;
  }
  set tooltipValue(value: string) {
    if (this.aide) {
      this.aideService.SharedAide[this.aide] = value;
    }
  }

  constructor(
    public dialogService: DialogService,
    public aideService: AideService,
    private permissionService: PermissionService,
  ) {}

  ngOnInit() {
    if (this.aide) {
      this.aideService.getAide(this.aide).subscribe(aideModel => {
        this.tooltipValue = aideModel ? aideModel.Aide : null;
      });
    }
  }

  isAdminAide(): boolean {
    return this.permissionService.hasAdministrateurPermission() && this.aideService.displayEditAide;
  }

  update(aide: AideModel) {
    if (aide) {
      this.tooltipValue = aide.Aide;
    }
    // Sinon popup fermé sans modification
  }

  popClick(event: Event) {
    // Pour eviter la propagation si l'aide est dans un bouton
    event.preventDefault();
    event.stopPropagation();

    // On masque les aides précédentes
    if (!this.popover.isOpen) {
      this.aideService.clearPops();
    }

    // On met à jour la liste des aides
    this.aideService.newPop(this.popover);
  }

  popHide(event: Event) {
    // Pour eviter la propagation si l'aide est dans un bouton
    event.preventDefault();
    event.stopPropagation();

    // On masque tout
    this.aideService.clearPops();
  }

  editAide(event: Event) {
    // Pour eviter la propagation si l'aide est dans un bouton
    event.preventDefault();
    event.stopPropagation();

    // On masque les aides précédentes
    this.aideService.clearPops();

    const ref = this.dialogService.open(AideEditComponent, {
      data: {
        code: this.aide,
        aide: <AideModel>{ Code: this.aide, Aide: this.tooltipValue },
        updateMethod: (da: AideModel) => {
          this.update(da);
        },
      },
      header: 'Edition Aide',
      closeOnEscape: false,
      dismissableMask: false,
      closable: false,
      width: '60%',
    });
    ref.onClose.subscribe((aide: AideModel) => {
      this.update(aide);
    });
  }
}
